import AssessmentServiceApi from "../../services/assessment-api";
import {
  createCookie,
  getPortalCD,
  readCookie,
  getFallbackIPAddress,
} from "../../utils/helpers";
import FunnelStepTypes from "../funnel-step/types";
import { toast } from "react-toastify";
import { invalidMailboxStatuses } from "../../utils/general-config";
import { EMPTY_GUID } from "../../utils/constants";

const createUserAccount = (data, t) => {
  return async function (dispatch) {
    let ipAddress = data?.ipAddress;
    if (!ipAddress) {
      ipAddress = await getFallbackIPAddress();
    }
    const loginAttemptReq = {
      emailAddress: data.email.trim(),
      ipAddress: ipAddress,
      attemptType: "Registration",
      visitorId: readCookie("visitorGuid"),
      visitId: readCookie("visitGuid"),
      createdBy: readCookie("visitorGuid"),
      portalCD: getPortalCD(),
      greCaptchaToken: "",
      isCaptchaRequired: true,
    };
    return AssessmentServiceApi.loginAttempt(loginAttemptReq)
      .then((loginResponse) => {
        if (
          loginResponse &&
          loginResponse.id !== EMPTY_GUID &&
          loginResponse.error === ""
        ) {
          return AssessmentServiceApi.createUser(data);
        } else {
          const isMaxAttempt =
            loginResponse?.statusCode === 426 &&
            loginResponse?.error === "maximum_login_attempt";
          const errorMsg = isMaxAttempt
            ? t("login.maximum_login_attempt")
            : t(loginResponse?.error);

          if (data.existingUserId) {
            return AssessmentServiceApi.getAssessmentAttemptByUserId(
              data.existingUserId,
            ).then((res) => {
              if (res && res.length > 0) {
                return AssessmentServiceApi.createUser(data);
              } else {
                toast.error(errorMsg);
              }
            });
          } else {
            toast.error(errorMsg);
          }
        }
      })
      .then((response) => {
        const isCapchaVisible =
          response?.emailVerificationSubStatus &&
          invalidMailboxStatuses.includes(response?.emailVerificationSubStatus);
        if (response && response.isValid) {
          const authData = {
            Username: data.email.trim(),
            email: data.email.trim(),
            userGuid: response.userGuid,
            password: data.password,
            isSocialLogin: false,
          };
          // createCookie("isValidEmail", response?.isEmailVerified, 1);
          // createCookie("userguid", response.userGuid, 1);
          dispatch(
            PushUserInformationToFunnelStep({
              userGUID: response.userGuid,
              email: data.email,
              gender: data.gender,
              isValidEmail: response?.isEmailVerified,
            }),
          );

          if (!isCapchaVisible) {
            return AssessmentServiceApi.AuthenticateExternalUser(authData).then(
              (authResponse) => {
                const { isAuth } = authResponse;
                // localStorage.setItem("jwtToken", jwtToken);
                // localStorage.setItem("refreshToken", refreshToken);
                // localStorage.setItem("expiresAt", expiresAt);
                // createCookie("jwtToken", jwtToken, 1);
                // createCookie("refreshToken", refreshToken, 1);
                // createCookie("expiresAt", expiresAt, 1);
                if (isAuth) {
                  dispatch(
                    PushUserInformationToFunnelStep({
                      userGUID: response.userGuid,
                      email: data.email,
                      gender: data.gender,
                      isPremium: response?.isPremium,
                      isValidEmail: response?.isEmailVerified,
                      isAuth: isAuth,
                    }),
                  );
                }
                return response;
              },
            );
          } else {
            return response;
          }
        } else {
          return response;
        }
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          const { ErrorData } = error.response.data;
          if (ErrorData?.UsernameAsPassword) {
            toast.error(t("account.usernamePasswordSame"));
          }
        } else {
          console.error("Unexpected Error:", error);
        }
        throw error; // rethrow for further upstream handling
      });
  };
};

const createExternalUserAccount = (data) => {
  return function (dispatch) {
    return AssessmentServiceApi.createExternalUser(data)
      .then((response) => {
        if (response && response.isValid) {
          const authData = {
            Username: data?.createUser?.email,
            email: data?.createUser?.email,
            userGuid: response.userGuid,
            isSocialLogin: true,
          };

          // createCookie("userguid", response.userGuid, 1);
          return AssessmentServiceApi.AuthenticateExternalUser(authData)
            .then((authResponse) => {
              const { isAuth } = authResponse;
              // const { jwtToken, refreshToken, expiresAt } = authResponse;
              // localStorage.setItem("jwtToken", jwtToken);
              // localStorage.setItem("refreshToken", refreshToken);
              // localStorage.setItem("expiresAt", expiresAt);
              // createCookie("jwtToken", jwtToken, 1);
              // createCookie("refreshToken", refreshToken, 1);
              // createCookie("expiresAt", expiresAt, 1);
              dispatch(
                PushUserInformationToFunnelStep({
                  userGUID: response.userGuid,
                  email: data?.createUser?.email,
                  gender: data?.createUser?.gender,
                  isAuth: isAuth,
                }),
              );
              return response;
            })
            .catch((error) => {
              console.error("Error during authentication:", error);
              throw error;
            });
        } else {
          return response;
        }
      })
      .catch((error) => {
        console.error("Error in createExternalUserAccount:", error);
        throw error;
      });
  };
};

const getContentLatestVersion = (data) => {
  return function () {
    return AssessmentServiceApi.getContentLatestVersion(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

const createContentMap = (data) => {
  return function () {
    return AssessmentServiceApi.createContentMap(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

const getAssessmentByAssessmentId = (id) => {
  return function () {
    return AssessmentServiceApi.getAssessmentByAssessmentId(id)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};
const verifyCapchaToken = (data, userPassword) => {
  return function (dispatch) {
    return AssessmentServiceApi.verifyCapchaToken(data)
      .then((response) => {
        if (response) {
          if (response && response.success) {
            const emailString = data.email;
            const authData = {
              Username: emailString.trim(),
              email: emailString.trim(),
              userGuid: data.userGuid,
              isSocialLogin: false,
              password: userPassword,
            };
            return AssessmentServiceApi.AuthenticateExternalUser(authData).then(
              (authResponse) => {
                const { isAuth } = authResponse;
                // localStorage.setItem("jwtToken", jwtToken);
                // localStorage.setItem("refreshToken", refreshToken);
                // localStorage.setItem("expiresAt", expiresAt);
                // createCookie("jwtToken", jwtToken, 1);
                // createCookie("refreshToken", refreshToken, 1);
                // createCookie("expiresAt", expiresAt, 1);
                dispatch(
                  PushUserInformationToFunnelStep({
                    userGUID: data.userGuid,
                    email: data.email,
                    gender: data.gender,
                    isPremium: data?.isPremium,
                    isAuth: isAuth,
                  }),
                );
                return response;
              },
            );
          }
          return response;
        }
      })
      .catch((error) => console.log("Verify Capcha Error", error));
  };
};

const PushUserInformationToFunnelStep = (userInformation) => ({
  type: FunnelStepTypes.SET_USERINFO,
  payload: userInformation,
});

export {
  createUserAccount,
  createExternalUserAccount,
  getContentLatestVersion,
  getAssessmentByAssessmentId,
  createContentMap,
  verifyCapchaToken,
};
